import _ from 'lodash';
import { Reducer } from 'redux';
import { GetMyAcctountPageContentsAction, GET_MY_ACCTOUNT_PAGE_CONTENTS } from './actions';
import { LogoutAction, LOGOUT } from 'store/user/actions';

export interface MyAcctontState {
  readonly id: number;
  readonly defaultFlag: boolean;
  readonly name: string;
  readonly page: string;
  readonly text: string;
  readonly home?: string;
}

export const defaultState: MyAcctontState = {
  id: 0,
  defaultFlag: false,
  name: '',
  page: '',
  text: '',
  home: '',
};

export const reducer: Reducer<MyAcctontState, GetMyAcctountPageContentsAction | LogoutAction> = (
  state = defaultState,
  action,
) => {
  switch (action.type) {
    case GET_MY_ACCTOUNT_PAGE_CONTENTS:
      return {
        // ...state,
        // home: action.payload[0]
        ...action.payload[0],
      };
    case LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default reducer;
